import {createContext,useContext} from 'react';
export type AdsContextValue={enabled:boolean;interstitialOpen:boolean;vignetteEligible?:boolean;visit:(storyId:string,index:number,count:number)=>void;transition:(next:()=>void)=>Promise<void>};
export const noAds:AdsContextValue={enabled:false,interstitialOpen:false,visit:()=>{},transition:async next=>next()};
export const AdsContext=createContext<AdsContextValue>(noAds);
export const useWebAds=()=>useContext(AdsContext);
